/*
 * @Author: cc
 * @Date: 2020-11-13 15:26:59
 * @LastEditTime: 2020-11-13 17:47:16
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\weixin\service\wxPreviewSuccess\wxPreviewSuccess.js
 * @Description: 
 */
/**
 *  预览弹出框
 *
 */
'use strict';
angular.module('wxPreviewSuccessModule', []).controller('wxPreviewSuccessController', ['$scope', 'draftParams', '$modalInstance', 'trsspliceString',
    function($scope, draftParams, $modalInstance, trsspliceString) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                msg: draftParams.msg,
                type: draftParams.type,
                accounts: draftParams.accounts,
            };
        }

        /**
         * [initData description]
         *
         * @return  {[type]}   [return description]
         */
        function initData() {
            if ($scope.status.msg.REPORTS[0].ERRNO !== '220') {
                return;
            }
            let successTip = '';
            let failTip = '';
            $scope.status.successAccountsNum = $scope.status.msg.REPORTS[0].RESULT.success.length;
            if ($scope.status.msg.REPORTS[0].RESULT.success.length > 5) {
                $scope.status.msg.REPORTS[0].RESULT.success.length = 5;
                successTip = '等';
            }
            $scope.status.failAccountsNum = $scope.status.msg.REPORTS[0].RESULT.fail.length;
            if ($scope.status.msg.REPORTS[0].RESULT.fail.length > 5) {
                $scope.status.msg.REPORTS[0].RESULT.fail.length = 5;
                failTip = '等';
            }
            $scope.status.successTip = trsspliceString.spliceString($scope.status.msg.REPORTS[0].RESULT.success, 'wxname', '、') + successTip;
            $scope.status.failTip = trsspliceString.spliceString($scope.status.msg.REPORTS[0].RESULT.fail, 'wxname', '、') + failTip;
        }

        /**
         * [confirm description] 提交
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $modalInstance.close('success');
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.close('fail');
        };
    },
]);
